// removed by extract-text-webpack-plugin
module.exports = {"noteIconWrapper":"_2kBehpitfkS_IVbyyApg3q","noteIcon":"_3jjunT0eOUJ1xHQpbBB0W3","noteTooltip":"_25xER_S6YKz8gF6xzX3DAj"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ProjectCellWrapper/ProjectCellWrapper.scss
// module id = 1681
// module chunks = 0